export const EVALUATION_FAQS = [
  { question: "Can we evaluate video meetings?", answer: "Use Envelaro Meet Lite from the calendar to invite your evaluation team and guests. The included limits are one host plus five guests, up to 60 minutes per meeting, and 600 participant-minutes shared by the organization per month." },
  {
    question: "Do we need to move our primary email?",
    answer: "No. Start with a secondary, test or otherwise non-critical domain. A production migration should happen only after the scope, backups and cutover responsibilities have been agreed.",
  },
  {
    question: "How long does the evaluation take?",
    answer: "The standard evaluation uses Envelaro's seven-business-day trial. We schedule onboarding near the beginning so your team has time to configure, use and review the service.",
  },
  {
    question: "Who should join from our company?",
    answer: "Include the person responsible for business email or domains and a decision-maker who can assess administration, support and commercial fit.",
  },
] as const;

